import { render, staticRenderFns } from "./RedPackageRule.vue?vue&type=template&id=224d2bae&scoped=true&"
import script from "./RedPackageRule.vue?vue&type=script&lang=js&"
export * from "./RedPackageRule.vue?vue&type=script&lang=js&"
import style0 from "./RedPackageRule.vue?vue&type=style&index=0&id=224d2bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d2bae",
  null
  
)

export default component.exports